import bannerRubrica from './banner-rubrica.svg';
import bannerStrutture from './banner-strutture.svg';

const basePath = process.env.RAZZLE_PUBLIC_PATH || '';

const FUser = `${basePath}/images/F_user.png`;
const MUser = `${basePath}/images/M_user.png`;
const NUser = `${basePath}/images/N_user.png`;

export { bannerRubrica, bannerStrutture, NUser, FUser, MUser};